// Each property's competitor-tracking switch as the settings last said it, published by whatever reads or saves them.

const tracking = new Map<number, boolean>();
const listeners = new Set<() => void>();

function notify(): void {
    for (const listener of [...listeners]) listener();
}

export function publishCompetitorTracking(connectionId: number, enabled: boolean): void {
    if (tracking.get(connectionId) === enabled) return;
    tracking.set(connectionId, enabled);
    notify();
}

/** Undefined until something has read or saved the property's settings. */
export function readCompetitorTracking(connectionId: number): boolean | undefined {
    return tracking.get(connectionId);
}

export function subscribeCompetitorTracking(listener: () => void): () => void {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}

/** Tests share the module; each starts knowing nothing. Tells nobody, so a reader still mounted does not start another read. */
export function forgetCompetitorTrackingForTests(): void {
    tracking.clear();
}
